import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'lucide-react';

type PaginationProps = {
  pageCount: number;
  onPageChange: (selected: number) => void;
  forcePage?: number;
};

const Pagination: React.FC<PaginationProps> = ({
  pageCount,
  onPageChange,
  forcePage,
}) => {
  return (
    <div
      className="flex justify-center mb-6"
      role="navigation"
      aria-label="Pagination"
    >
      <ReactPaginate
        breakLabel="..."
        nextLabel={<ChevronRight className="w-4 h-4" aria-hidden="true" />}
        previousLabel={<ChevronLeft className="w-4 h-4" aria-hidden="true" />}
        onPageChange={({ selected }) => onPageChange(selected)}
        pageRangeDisplayed={4}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        forcePage={forcePage}
        containerClassName="flex items-center gap-2"
        pageClassName="text-sm"
        pageLinkClassName="w-8 h-8 flex items-center justify-center rounded-full border hover:bg-gray-100"
        previousLinkClassName="p-2 rounded-full border hover:bg-gray-100"
        nextLinkClassName="p-2 rounded-full border hover:bg-gray-100"
        activeLinkClassName="bg-red-600 text-white"
        breakClassName="text-gray-400"
        disabledClassName="opacity-50 pointer-events-none"
      />
    </div>
  );
};

export default Pagination;
